// Plural Actions
export const GET_MW_ACCOUNTS = "GET_MW_ACCOUNTS";
export const getMWAccounts = (opts = {}) => {
  const params = opts.refresh ? { refresh: "true" } : {};
  const request = axios.get("/moneyworks/accounts.json", { params });
  return {
    type: GET_MW_ACCOUNTS,
    payload: request,
  };
};
